import { Row, ContentCard, Tag } from "@narmi/design_system";

import { moneyFormatter } from "./PaymentTable";
import { AdminApiSchema } from "../../api_utils";
import { FEDNOW_TRANSACTION_STATES } from "./codesets";
import styles from "./table.module.css";
import { dateOptions } from "./PaymentDetailDrawer";

type FedNowTransaction = AdminApiSchema.components["schemas"]["FedNowTransactionAdmin"];

function RelatedTransaction({ txn }: { txn: FedNowTransaction }) {
  return (
    <div className="padding--top--s">
      <ContentCard
        kind="button"
        paddingSize="s"
        onClick={() => window.open(`/fednow/declined/${txn.id}`, "_blank")}
      >
        <Row gapSize="m">
          <Row.Item>
            <p
              className="padding--bottom--xs fontWeight--semibold whiteSpace--truncate"
              style={{ maxWidth: "100%" }}
            >
              {`${txn.user.first_name} ${txn.user.last_name}`}
            </p>
          </Row.Item>
          <Row.Item shrink>
            <div className="padding--bottom--xs">
              <Tag label={txn.state && FEDNOW_TRANSACTION_STATES[txn.state]}></Tag>
            </div>
          </Row.Item>
        </Row>
        <Row>
          <Row.Item>
            <p>{new Date(txn.updated_at).toLocaleString("en-US", dateOptions)}</p>
          </Row.Item>
          <Row.Item shrink>
            <p>{moneyFormatter.format(txn.amount_cents / 100)}</p>
          </Row.Item>
        </Row>
      </ContentCard>
    </div>
  );
}

export default function RelatedEvaluations({
  relatedTransaction,
}: {
  relatedTransaction?: FedNowTransaction;
}) {
  return relatedTransaction &&
    (relatedTransaction.state === "overridden" ||
      relatedTransaction.state === "overridden_settled") ? (
    <div className={`${styles.transactionDetailContainer} margin--y padding--all`}>
      <h4 className="fontFamily--body">Related declined payment</h4>
      <RelatedTransaction txn={relatedTransaction} />
    </div>
  ) : null;
}
